import React, {Component} from "react";
import moment from 'moment';

function getData(data, loading) {
    if(loading) {
        return <div style={{padding:'30px'}}>Загружается...</div>
    }

    if(data && data.length < 1){
        return <div style={{padding:'30px'}}>Операций нет.</div>
    }

    return (<ul className="items-list operations-history-list">
        {
            data.map((item, index) =>
                <li key={index} className="list-item">
                    <div className="name">{item.title}</div>
                    <div className="date">{moment(item.created_at).format('DD.MM.YYYY, HH:mm:ss')}</div>
                    <div className={parseFloat(item.change_balance) < 0 ? "balance-change text_red" : "balance-change text_green"}>
                        {item.change_balance} р.
                    </div>
                </li>
            )
        }
    </ul>)
}

export default (props) => {

    const {
        user,
        selectedCompany,
        onClose,
        onMoreClick,
        data,
        next,
        loading,
    } = props;

    if(!user) return false;

    return(
        <div className="white-block-content">
            <div style={{padding: '30px 30px 0 30px', display:'flex', flexDirection:'row'}}>
                <div style={{flexGrow:1, marginRight: '20px'}}>      
                    <div style={{fontSize: '1rem', textTransform: 'uppercase', fontWeight:'bold', color: '#333', marginBottom: '10px'}}>
                        {user.user.first_name + " " + user.user.last_name + " - " + selectedCompany.title}
                    </div>                  
                    <div style={{fontSize: '1rem', textTransform: 'uppercase', color: '#979797', marginBottom: '10px'}}>Детализация затрат</div>
                </div>
            </div>

            {getData(data, loading)}

            <div className="actions">
                {
                    next ? 
                    <div className="big-button empty-button">
                        <button onClick={() => onMoreClick(next)}>Загрузить еще</button>
                    </div>
                    : null
                }
                <div className="big-button empty-button">
                    <button onClick={() => onClose()}>Назад</button>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/AccountLaw/DetailTransaction.js